import { getTranslateNsT } from "@/utils/getTranslateNsT";
import request from "project-config/services/request/request";
const t = getTranslateNsT("childManager");

export function useValidator() {
  const enterpriseAliasValidator = async (value: string) => {
    if (
      !value ||
      !/^(?!-)(?!.*--)(?=.*[a-zA-Z0-9-]$)[a-zA-Z0-9-]{1,60}$/.test(value)
    ) {
      return Promise.reject(t("dingtalk_subaccount_setting_error_tip"));
    }
    const { code } = await request.post(
      "/api/rendering/user/validateEnterpriseAlias",
      {
        enterpriseAlias: value,
      }
    );
    if (code === 701) {
      return Promise.reject(t("dingtalk_subaccount_setting_save_error"));
    }
    return Promise.resolve();
  };
  return {
    enterpriseAliasValidator,
  };
}

export function useValidatorChinese() {
  const enterpriseAliasValidator = async (value: string) => {
    // eslint-disable-next-line no-useless-escape
    if (!value || !/^[\u4e00-\u9fa5a-zA-Z0-9\-\(\)\（\）]{1,60}$/.test(value)) {
      return Promise.reject(t("dingtalk_subaccount_setting_error_tip"));
    }
    const { code } = await request.post(
      "/api/rendering/user/validateEnterpriseAlias",
      {
        enterpriseAlias: value,
      }
    );
    if (code === 701) {
      return Promise.reject(t("dingtalk_subaccount_setting_save_error"));
    }
    return Promise.resolve();
  };
  return {
    enterpriseAliasValidator,
  };
}
